import { Country } from "../shared/types/countries";

export const Roles = [{
    role: 'advisor',
    image: '/images/talk-now/advisor.png',
    description: 'advisorsIntro',
  },
  {
    role: 'teacher',
    image: '/images/talk-now/teacher.png',
    description: 'teachersIntro',
  }
];

export const getRolesByCountryCode = (countryCode: string) => {
  if (countryCode === Country.VIETNAM) {
    return Roles.filter(role => role.role !== 'advisor');
  }
  return Roles;
};


// WEBPACK FOOTER //
// ./ts/app/contact-us/RoleConfig.ts